/* ============================================================
   androidWorkflow.js — simpan/muat workflow + panggilan AI (Fasa 4)
   ============================================================
   Workflow disimpan dalam config/android_workflows (admin read+write via
   rules sedia ada — TIADA deploy rules). Map berkunci id supaya banyak
   workflow dalam satu doc (bilangan kecil; jauh dari had 1 MB).

   AI vision = callable `androidAiPropose` (admin sahaja, server). Perlu
   deploy function dahulu (gated) sebelum berfungsi.
   ============================================================ */

import { db, functions, auth } from '../firebase';
import { doc, setDoc, updateDoc, deleteField, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

const WF_DOC = ['config', 'android_workflows'];
export const WORKFLOW_SCHEMA_VERSION = 1;
export const DYNAMIC_PARAMS = ['{{video_file}}', '{{caption}}', '{{product_reference}}'];

// Langgan senarai workflow tersimpan (admin). cb({id: workflow}).
export function subscribeWorkflows(cb) {
  return onSnapshot(
    doc(db, ...WF_DOC),
    (snap) => cb(snap.exists() ? (snap.data().workflows || {}) : {}),
    () => cb({}),
  );
}

export async function saveWorkflow(wf) {
  if (!wf?.id) throw new Error('Workflow perlu id.');
  await setDoc(doc(db, ...WF_DOC), {
    workflows: {
      [wf.id]: { ...wf, updatedAt: serverTimestamp(), updatedBy: auth.currentUser?.email || '' },
    },
  }, { merge: true });
}

export async function deleteWorkflow(id) {
  await updateDoc(doc(db, ...WF_DOC), { [`workflows.${id}`]: deleteField() });
}

// Panggil AI vision (server). payload = { imageBase64, goal, model?, context }.
export async function aiPropose(payload) {
  const fn = httpsCallable(functions, 'androidAiPropose');
  const res = await fn(payload);
  return res.data; // { proposal, usage, model }
}
